import React from "react";

import { Box, CampoEstatico, Card, TipoCampoEstatico } from "@intechprev/componentes-web";

interface IProps {
  salario: Array<any> | null;
  valorInvalidez: number;
  valorFuneral: number;
}

export const UltimasContribuicoes: React.FC<IProps> = ({
  salario,
  valorInvalidez,
  valorFuneral
}) => {

  if (salario !== null && salario !== undefined && salario.length > 0) {
    return (
      <Box renderRow={true}>
        <div className={"card mb-3 border-0"}>
          <div className={"card-title"}>
            {"Salário de Participação"}

            <span className={`badge badge-${Card.TipoBadge.success}`}>{`em ${salario[0].MES_REF}/${salario[0].ANO_REF}`}</span>

          </div>
        </div>

        <div className={"table-responsive"}>
          <table className={"table table-striped table-sm"}>

            <caption>
              {"O salário é limitado para a cobertura e a contribuição do benefício de pensão em "}
              <CampoEstatico valor={valorInvalidez} tipo={TipoCampoEstatico.dinheiro} />
              {" e dos benefícios de pecúlio e auxílio-funeral em "}
              <CampoEstatico valor={valorFuneral} tipo={TipoCampoEstatico.dinheiro} />
              {"."}
            </caption>

            <thead className={"thead-light"}>
              <tr>
                <th>Benefício</th>
                <th className={"text-right"}>Salário de Participação</th>
                <th className={"text-right"}>%</th>
              </tr>
            </thead>
            <tbody>
              {salario.map((contrib: any, index: number) => {
                return (
                  <tr key={index}>
                    <td>{contrib.DS_TIPO_CONTRIBUICAO}</td>
                    <td className={"text-right"}>
                      <CampoEstatico valor={contrib.SRC.toLocaleString("pt-Br")} />
                    </td>
                    <td className={"text-right"}>
                      {contrib.PERC_FAIXA !== 0 ?
                        <CampoEstatico valor={contrib.PERC_FAIXA.toFixed(4)} /> :
                        <CampoEstatico valor={"-"} />
                      }
                    </td>
                  </tr>
                );
              })}

            </tbody>
          </table>
        </div>
      </Box>
    )
  }

  return (
    null
  );
}